import { Pagination, styled } from '@mui/material';

export const StyledPagination = styled(Pagination)(() => ({
  margin: '8px 16px 0px 0px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));
